<template>
  <div class="h-full w-full bg- flex relative z">
    <!-- <div>test {{ webMapLocal }}</div> -->
    <div class="flex-1 relative">
      <GmapMap
        ref="mapRef"
        :center="center"
        :zoom="zoom"
        @zoom_changed="
          (v) => {
            zoom = v;
          }
        "
        class="w-full h-full"
        :options="{
          gestureHandling: 'greedy',
          mapTypeControl: true,
          zoomControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: false,
          fullscreenControl: true,
        }"
        :map-type-id="webMapLocal"
      >
        <gmap-polygon
          v-if="webMapShowPOILocal"
          v-for="poi in mapPOIData"
          :key="poi.name"
          :paths="poi.paths"
          :options="{
            fillColor: poi.fillColor,
            fillOpacity: poi.fillOpacity,
            strokeWeight: poi.strokeWeight,
          }"
          @click="poiClick(poi)"
        />
        <gmap-cluster
          @click="clusterClicked"
          imagePath="/cluster/m"
          v-if="!refresh"
        >
          <GmapCustomMarker
            :key="index"
            v-for="(m, index) in filteredMarkers"
            :marker="m.position"
            :clickable="true"
            @click.native="markerClicked(m.position, m)"
            @dblclick.native="markerDblclicked(m.position, m)"
            alignment="center"
          >
            <MapViewMarker :data="m" />
          </GmapCustomMarker>
        </gmap-cluster>

        <gmap-heatmap-layer
          v-show="showHeatmap"
          :data="useHeatmap"
          :options="{ radius: heatmapRadius }"
        />
      </GmapMap>
      <div
        class="absolute top-0"
        style="
          min-height: 50px;
          left: 192px;
          margin-left: 20px;
          width: calc(100% - (192px + 20px) - 60px);
          gap: 15px;
        "
      >
        <div
          class="absolute bg-primary text-white p-4 py-2 rounded-b-lg"
          style="
            left: 50%;
            top: 100%;
            position: absolute;
            transition: 0.2s;
            z-index: 1;
          "
          :style="{
            transform: `translate(-50%, ${isLoadingMain ? 0 : -100}%)`,
          }"
        >
          Fetching data
        </div>
        <div
          class="relative flex h-full w-full overflow-x-auto bg-white shadow-md p-3 rounded-b-lg items-center justify-between"
          style="z-index: 99999"
        >
          <assets-select
            @selected="(v) => (selectedUnits = v)"
            style="max-width: 500px"
            :class="[isLoadingMain || isLoading ? 'pointer-events-none' : '']"
            :disable="isLoadingMain || isLoading"
          />
          <div class="flex flex-1 justify-end items-center" style="gap: 15px">
            <filter-btn
              :stat="stat"
              @filter-type="filtering"
              :filter="filterType"
              style="white-space: nowrap"
            />
            <vs-button
              style="white-space: nowrap"
              :type="webMapShowPOILocal ? 'filled' : 'border'"
              :color="webMapShowPOILocal ? 'primary' : 'danger'"
              size="small"
              @click="webMapShowPOILocal = !webMapShowPOILocal"
              >Toggle POI</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- details panel -->
    <div
      class="h-full top-0 bg-white right-0"
      style="
        transition: 0.2s;
        box-shadow: -5px 2px 5px rgba(0, 0, 0, 0.178);
        z-index: 2;
      "
      :style="{ width: `${detailsPanel ? '400px' : '0%'}` }"
    >
      <DetailsPanel
        :data="selectedUnitDetails"
        :isLoading="isLoading"
        :geoPOIData="geoPOIData"
        @get-chart="getChartData"
        :showHeatmapProp="showHeatmap"
        @get-unit="getUnit"
        @show-heatmap="
          (v) => {
            showHeatmap = v;
          }
        "
      />
      <button
        @click="detailsPanel = !detailsPanel"
        :aria-label="detailsPanel ? 'Collapse Panel' : 'Expand Panel'"
        class="absolute panel-button"
        style="box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.466)"
      >
        <vx-tooltip
          :text="detailsPanel ? 'Collapse Panel' : 'Expand Panel'"
          position="left"
        >
          <img
            :style="{ transform: `scale(${detailsPanel ? -1 : 1})` }"
            src="//maps.gstatic.com/tactile/pane/arrow_left_1x.png"
          />
        </vx-tooltip>
      </button>
    </div>
    <!-- modal -->
    <Transition name="scale">
      <modal-view
        v-if="modalOpen"
        @close-modal="modalOpen = false"
        :data="chartData"
      />
    </Transition>
  </div>
</template>

<script>
import ModalView from './ModalView.vue';
import DetailsPanel from './DetailsPanel.vue';
import AssetsSelect from './AssetsSelect.vue';
import FilterBtn from './FilterBtn.vue';
import MapViewMarker from './MapViewMarker.vue';
import GmapCustomMarker from 'vue2-gmap-custom-marker';

// import { components } from 'gmap-vue';
import GmapCluster from 'gmap-vue/dist/components/cluster';
import { gmapApi } from 'gmap-vue';

export default {
  components: {
    GmapCluster,
    GmapCustomMarker,
    MapViewMarker,
    FilterBtn,
    AssetsSelect,
    DetailsPanel,
    ModalView,
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(this.mapPOIData);
      if (this.$route.params.assetName && this.$route.params.assetId) {
        this.selectedUnits.push(Number(this.$route.params.assetId));
      }
    });
  },
  computed: {
    heatmapRadius() {
      let radius = 30;
      this.zoom < 9 ? (radius = 20) : void 0;
      this.zoom > 11 ? (radius = 50) : void 0;
      this.zoom > 14 ? (radius = 80) : void 0;
      return radius;
    },
    google: gmapApi,
    useHeatmap() {
      if (this.google && this.showHeatmap && this.heatmapData) {
        return this.heatmapData.map((e) => new google.maps.LatLng(e));
      }
      return [];
    },
    filteredMarkers() {
      if (this.markers.length == 0) {
        return [];
      } else {
        //
        return this.filterType[0] == 'All'
          ? this.markers
          : this.markers.filter((e) => {
              return this.statusList[e.data.status] == this.filterType[0]
                ? e
                : void 0;
            });
      }
    },
  },
  watch: {
    webMapShowPOILocal: {
      handler() {
        localStorage.setItem(
          'webmap-mapview-showpoi',
          JSON.stringify(this.webMapShowPOILocal),
        );
      },
      immediate: true,
    },
    selectedUnits: {
      handler() {
        this.selectedUnits.length == 0 ? this.init() : this.getUnitsDetails();
      },
      deep: true,
    },
    markers: {
      handler() {
        if (this.markers.length > 1) {
          if (!this.selectedUnit) this.fitBounds(this.markers);
        }
        if (this.markers.length == 1) {
          this.fitBounds(this.markers, 'none');
          this.selectedUnit = this.markers[0].data.assetId;
        }
        if (this.markers.length == 0) {
          // console.log('whoops');
        }
      },
      deep: true,
    },
    selectedUnit: {
      async handler(newVal, oldVal) {
        if (!this.selectedUnit) {
          this.heatmapData = null;
          return;
        }
        if (newVal == oldVal) {
          // we define this in lap
        } else {
          this.showHeatmap = null;
          this.detailsPanel = true;
          await this.displayDetails(this.selectedUnit);
          if (this.selectedUnitDetails) {
            await this.getHeatmap();
          }
        }
      },
    },
    selectedUnitDetails: {
      async handler() {
        if (this.selectedUnitDetails) {
          await this.getHeatmap();
        }
      },
      deep: true,
    },
    filterType() {
      this.fitBounds(this.filteredMarkers);
    },
    lap: {
      async handler() {
        this.time = this.seconds;
        await this.getUnitsDetails();
        if (this.selectedUnit) {
          this.$refs.mapRef.$mapPromise.then(async (map) => {
            if (this.selectedUnitDetails) {
              map.panTo({
                lat: this.selectedUnitDetails.lat,
                lng: this.selectedUnitDetails.lng,
              });
            }
            await this.displayDetails(this.selectedUnit);
          });
        }
      },
    },
  },
  data() {
    return {
      heatmapData: null,
      showHeatmap: false,
      refresh: false,
      chartData: null,
      modalOpen: false,
      statusList: {
        Moving: 'Move',
        Idling: 'Idle',
        Parked: 'Park',
        Inactive: 'Inactive',
      },
      lap: 0,
      time: 10,
      seconds: 60,
      timer: null,
      detailsPanel: false,
      zoom: 8,
      center: { lat: 3.910187, lng: 102.119262 },
      webMapLocal: localStorage.getItem('webmap-mapview-maptype') || 'roadmap',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      webMapShowPOILocal: JSON.parse(
        localStorage.getItem('webmap-mapview-showpoi'),
      ),
      poiReferences: [],
      isLoading: false,
      isLoadingMain: false,
      markers: [],
      stat: null,
      filterType: ['All'],
      selectedUnits: [],
      selectedUnit: null,
      selectedUnitDetails: null,
    };
  },
  methods: {
    init() {
      this.refresh = true;
      this.markers = [];
      this.stat = null;
      this.detailsPanel = false;
      this.filterType = ['All'];
      this.selectedUnit = null;
      this.selectedUnitDetails = null;
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setZoom(8);
        map.panTo({ lat: 3.910187, lng: 102.119262 });
      });
      setTimeout(() => {
        this.refresh = false;
      }, 10);
    },
    async getUnitsDetails() {
      if (!this.timer) {
        this.startTimer();
      }
      this.isLoadingMain = true;
      try {
        let response = await this.$http.post(
          `dashboardListener/${this.userInfo.uid}`,
          {
            selectedUnits: this.selectedUnits,
          },
        );
        if (response.status == 200 && response.data.success) {
          let res = response.data.mapMarkerData;
          this.stat = response.data.stat;
          let arr = [];
          res.forEach((data) => {
            let obj = {
              position: { lat: data.lat, lng: data.lng },
              data,
            };

            arr.push(obj);
          });

          this.markers = arr;
        }
        this.isLoadingMain = false;
      } catch (error) {
        console.log(error);
        this.isLoadingMain = false;
      }
    },
    markerClicked(e, m) {
      this.$refs.mapRef.$mapPromise.then(async (map) => {
        if (map.zoom < 12) {
          map.setZoom(13);
        }
        map.panTo(e);
        if (m.data.assetId == this.selectedUnit) {
          this.lap++;
        } else {
          this.selectedUnit = m.data.assetId;
          await this.getUnitsDetails();
          this.time = this.seconds;
        }
      });
    },
    markerDblclicked(e) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setZoom(map.zoom + 1);
        map.panTo(e);
      });
    },
    clusterClicked(e) {
      let markers = e.markers_;
      this.fitBounds(markers);
    },
    fitBounds(markers, zoom) {
      if (markers.length == 0) return;
      this.$refs.mapRef.$mapPromise.then((map) => {
        let currentZoom = map.zoom;

        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < markers.length; i++) {
          if (markers[i].getPosition) {
            bounds.extend(markers[i].getPosition());
          } else {
            let gmarker = new google.maps.Marker({
              ...markers[i],
              map: this.map,
            });
            bounds.extend(gmarker.getPosition());
          }
        }
        map.fitBounds(bounds);
        if (zoom == 'none') {
          map.setZoom(currentZoom);
        } else if (!zoom) {
          zoom = 0.5;
          map.setZoom(map.zoom - zoom);
        } else {
          map.setZoom(zoom);
        }
      });
    },
    filtering(filter, v2) {
      if (JSON.stringify(filter) == JSON.stringify(this.filterType)) return;
      if (!v2) {
        this.filterType = filter;
      }
    },
    async displayDetails(assetId) {
      // let showHeatmap = [];
      // if (this.selectedUnitDetails.assetId == assetId)
      //   showHeatmap.push(this.showHeatmap);

      this.selectedUnitDetails = null;
      this.isLoading = true;
      try {
        let response = await this.$http.post(
          `singleUnitDetails/${assetId}/${this.userInfo.uid}`,
          {
            geoPOIData: this.geoPOIData,
          },
        );
        if (response.status == 200 && response.data.success) {
          this.selectedUnitDetails = response.data.unitDetails;
          if (
            (this.userInfo.streetview == true &&
              this.selectedUnitDetails.status == 'Moving') ||
            (this.userInfo.streetview == 'true' &&
              this.selectedUnitDetails.status == 'Moving')
          ) {
            this.selectedUnitDetails['permission'] =
              await this.streetViewAvailability(
                response.data.unitDetails.lat,
                response.data.unitDetails.lng,
              );
            this.isLoading = false;
            // this.showHeatmap = showHeatmap[0];
          } else {
            this.selectedUnitDetails['permission'] = 1;
            this.isLoading = false;
          }
        } else if (response.data.error) {
          console.log(response.data.error);
          // this.isLoading = false;
        } else {
          console.log('something happened', response);
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async streetViewAvailability(lat, lng) {
      var streetViewService = new google.maps.StreetViewService();

      return await streetViewService.getPanorama(
        {
          location: new google.maps.LatLng(lat, lng),
          source: google.maps.StreetViewSource.OUTDOOR,
        },
        function (data, status) {
          if (status === google.maps.StreetViewStatus.OK) {
            // OK
            return true;
          } else {
            // error or no results
            return false;
          }
        },
      );
    },
    async getHeatmap() {
      try {
        let response = await this.$http.post(
          `web-heatmap/${this.selectedUnitDetails.unitId}`,
          {},
        );
        if (response.status == 200 && response.data.success) {
          this.heatmapData = response.data.heatmap;
        } else if (response.data.error) {
          console.log(response.data.error);
        } else {
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      }
    },
    poiClick(poi) {
      alert(poi.name);
    },
    getUnit() {
      let zoom = this.zoom;
      this.filterType = ['All'];
      setTimeout(() => {
        this.fitBounds(
          [
            {
              position: {
                lat: this.selectedUnitDetails.lat,
                lng: this.selectedUnitDetails.lng,
              },
            },
          ],
          zoom,
        );
      }, 100);
    },
    getChartData(v) {
      this.chartData = null;
      setTimeout(() => {
        this.chartData = v;
        this.modalOpen = true;
      }, 10);
    },
    startTimer() {
      this.time = this.seconds;
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          this.resetTimer();
        }
      }, 1000);
    },
    resetTimer() {
      clearInterval(this.timer);
      if (this.selectedUnits.length != 0) {
        this.lap++;
        this.startTimer();
      } else {
        this.time = this.seconds;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer); // Clear the interval to avoid memory leaks
  },
};
</script>

<style scoped>
.panel-button {
  transform: translate(-100%, -50%);
  top: 50%;
  white-space: normal;
  font: inherit;
  list-style: none;
  margin: 0;
  outline: 0;
  overflow: visible;
  padding: 0;
  vertical-align: baseline;
  color: inherit;
  border: 0;
  box-shadow:
    0 1px 2px rgba(60, 64, 67, 0.3),
    0 2px 6px 2px rgba(60, 64, 67, 0.15);
  width: 23px;
  height: 48px;
  cursor: pointer;
  border-left: 1px solid #dadce0;
  background: #fff 7px center/7px 10px no-repeat;
  background-color: #fff;
  border-radius: 8px 0 0 8px;
}
</style>

<style>
.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
}

.scale-enter,
.scale-leave {
  opacity: 0;
  transform: scale(0.9);
}
</style>
